import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import { DefaultDocument, SeriePredeterminada, SubSeriePredeterminada } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { promise } from 'protractor';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ManageRestrictionDocumentDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

    /**
   * Consultar todas las series
   *
   * @returns {Promise<SeriePredeterminada[]>}
   * @memberof ManageRestrictionDocumentDataService
   */
     getSeriesDocumentary(): Promise<SeriePredeterminada[]> {
      return new Promise((resolve, reject) => {
        this.http.get<SeriePredeterminada[]>(this.api.get('adminSerie')).subscribe(
          seriesDocumentary => {
            resolve(seriesDocumentary);
        },
        err => {
          reject(err);
        });
      });
    }
  
    /**
     * Consutar todas las subseries
     *
     * @returns {Promise<SubSeriePredeterminada[]>}
     * @memberof ManageRestrictionDocumentDataService
     */
    getSubseriesDocumentary(): Promise<SubSeriePredeterminada[]> {
      return new Promise((resolve, reject) => {
        this.http.get<SubSeriePredeterminada[]>(this.api.get('adminSubSerie')).subscribe(
          subSeriesDocumentary => {
            resolve(subSeriesDocumentary);
          },
          err => {
            reject(err);
          }
        );
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-restriction-document/shared/manage-restriction-document.data.service.ts